export default "__VITE_ASSET__C4MNOrz4__"